import client from './client.js';

// Dados do paciente logado (nome vem descriptografado pelo backend)
export const getMe = async () => {
  const { data } = await client.get('/patients/me');
  return data; // { user_id, email, first_name, last_name, cpf_masked, ... }
};

// Passo 2 do cadastro — roda logo após auth.registerIdentity() (ou após um
// login numa conta iam já existente), com o Bearer já disponível.
export const completeRegistration = async ({
  cpf, firstName, lastName, birthDate, phone, cep, acceptTerms, acceptPrivacy,
}) => {
  const { data } = await client.post('/patients/complete-registration', {
    cpf: cpf.replace(/\D/g, ''),
    first_name: firstName,
    last_name: lastName,
    birth_date: birthDate,
    phone: phone.replace(/\D/g, ''),
    cep,
    accept_terms: acceptTerms,
    accept_privacy: acceptPrivacy,
  });
  return data; // PatientOut
};

// Editar Perfil — só envia os campos informados (PATCH parcial)
export const updateMe = async ({
  firstName, lastName, phone, cep, address, complement, neighborhood, city, state,
} = {}) => {
  const body = {};
  if (firstName !== undefined) body.first_name = firstName;
  if (lastName !== undefined) body.last_name = lastName;
  if (phone !== undefined) body.phone = phone.replace(/\D/g, '');
  if (cep !== undefined) body.cep = cep;
  if (address !== undefined) body.address = address;
  if (complement !== undefined) body.complement = complement;
  if (neighborhood !== undefined) body.neighborhood = neighborhood;
  if (city !== undefined) body.city = city;
  if (state !== undefined) body.state = state;
  const { data } = await client.patch('/patients/me', body);
  return data; // PatientOut
};

// Autofill do formulário de endereço — mesma cascata (BrasilAPI → ViaCEP →
// Google por último) usada na geocodificação da busca de laboratório.
export const lookupCep = async (cep) => {
  const { data } = await client.get(`/patients/cep/${cep.replace(/\D/g, '')}`);
  return data; // { street, neighborhood, city, state, complete }
};

export const uploadAvatar = async (file) => {
  const form = new FormData();
  form.append('file', file);
  const { data } = await client.post('/patients/me/avatar', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data; // PatientOut (avatar_url já como URL assinada)
};

export const changePassword = async ({ currentPassword, newPassword, confirmPassword }) => {
  const { data } = await client.post('/patients/me/change-password', {
    current_password: currentPassword,
    new_password: newPassword,
    confirm_password: confirmPassword,
  });
  return data;
};
